import { render, staticRenderFns } from "./DefectGrade.vue?vue&type=template&id=cbd534ac"
import script from "./DefectGrade.vue?vue&type=script&lang=js"
export * from "./DefectGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports